import React, { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import Testimonial from '../components/Testimonial'
import Footer from '../components/Footer'
import Menu from '../components/Navbar'
import Nav from 'react-bootstrap/Nav';
import { Container} from 'react-bootstrap'
import imgArsitektur from '../img/arsitektur.png'
import imgInterior from '../img/interior.png'
import imgKonstruksi from '../img/konstruksi.png'
import AnimatedNumbers from "react-animated-numbers";

// image import
import Portfolio1 from '../img/aboutus1.png'
import Portfolio2 from '../img/aboutus2.png'
import Portfolio3 from '../img/aboutus3.png'

const Home = () => {

    const Image = () => {
        return <img src={Portfolio1} alt="" />
      }
      const Image2 = () => {
        return <img src={Portfolio2} alt="" />
      }
      const Image3 = () => {
        return <img src={Portfolio3} alt="" />
    }

    const [loading, setLoading] = useState(false)
    const [loading1, setLoading1] = useState(false)
    const [loading2, setLoading2] = useState(false)

    const onClick = () => {
        setLoading(true)
    }
    const onClick1 = () => {
        setLoading1(true)
    }
    const onClick2 = () => {
        setLoading2(true)
    }

    const [num, setNum] = React.useState(42);
    const [num1, setNum1] = React.useState(33);
    const [num2, setNum2] = React.useState(27);

    const handleAnchorClick = event => {
        event.currentTarget()
    }
  return (
    <>
    <Menu />
    <Container fluid className="content1">
        <div className="Image">
            <div className="container-image">
                <div className="paragrafHome">
                    <h1>Designed to last. Built to impress</h1>
                    <p>Dari hunian, kantor, hingga fasilitas olahraga, setiap proyek Mortara dijalankan melalui
perencanaan yang terstruktur, pengawasan lapangan yang disiplin, dan hasil akhir yang
memenuhi standar kualitas.</p>
                    <a onClick={handleAnchorClick} href="https://wa.me//+6281223492192" target="_blank" rel="noreferrer">
                    <button type="submit" className="btnContact btn btn-light">Konsultasi Gratis via Whatsapp</button>
                    </a>
                </div>
            </div>
        </div>
    </Container>

    <Container fluid className="content2">
        <div className="whyMortara">
            <div className="container-body">
                <Container fluid className="containerOurService">
                    <div className="ourService">
                        <div className="card1">
                            <h1>Arsitektur</h1>
                            <img src={ imgArsitektur } alt="" />
                            <p>Perencanaan arsitektur dengan pendekatan teknis yang terukur, mulai dari tata ruang,
struktur, hingga detail fasad. Mortara memastikan desain selaras dengan fungsi dan
standar konstruksi.</p>
                            <Nav.Link className="linkButton" href="/arsitektur">
                                <button type="submit" className="btnForm btn btn-dark" onClick={onClick}>
                                    {loading ? 'Waiting...': 'Learn More >>'}
                                </button>
                            </Nav.Link>
                        </div>
                        <div className="card1">
                            <h1>Desain Interior</h1>
                            <img src={ imgInterior } alt="" />
                            <p>Perancangan interior yang mempertimbangkan fungsi, material, dan detail eksekusi.
Setiap ruang dirancang estetis namun tetap realistis untuk diwujudkan sesuai standar
konstruksi Mortara.</p>
                            <Nav.Link className="linkButton" href="/interior-design">
                                <button type="submit" className="btnForm btn btn-dark" onClick={onClick1}>
                                    {loading1 ? 'Waiting...': 'Learn More >>'}
                                </button>
                            </Nav.Link>
                        </div>
                        <div className="card1">
                            <h1>Konstruksi</h1>
                            <img src={ imgKonstruksi } alt="" />
                            <p>Eksekusi konstruksi yang disiplin dan presisi, sesuai gambar kerja dan spesifikasi teknis.
Tim Mortara memastikan kualitas pekerjaan terukur dari awal hingga serah terima.</p>
                            <Nav.Link className="linkButton" href="/konstruksi">
                                <button type="submit" className="btnForm btn btn-dark" onClick={onClick2}>
                                    {loading2 ? 'Waiting...': 'Learn More >>'}
                                </button>
                            </Nav.Link>
                        </div>
                    </div>
                </Container>
            </div>
        </div>
    </Container>

    <div className="hero">
        <div className="content-hero">
            <h1 className="text">Proyek Berjalan.</h1>
            <div className="containerMotion">
                <div className="bg">
                    <div className="motion">
                        <h3>Arsitektur</h3>
                        <h1 className="d-flex">
                            <AnimatedNumbers
                                includeComma
                                animateToNumber={num}
                                fontStyle={{ fontSize: 80 }}
                                configs={[
                                    { mass: 1, tension: 220, friction: 100 },
                                    { mass: 1, tension: 180, friction: 130 },
                                    { mass: 1, tension: 280, friction: 90 },
                                    { mass: 1, tension: 180, friction: 135 },
                                    { mass: 1, tension: 260, friction: 100 },
                                    { mass: 1, tension: 210, friction: 180 },
                                ]}
                                >
                            </AnimatedNumbers>+
                        </h1>
                    </div>
                    <div className="motion">
                        <h3>Desain Interior</h3>
                        <h1 className="d-flex">
                            <AnimatedNumbers
                                includeComma
                                animateToNumber={num1}
                                fontStyle={{ fontSize: 80 }}
                                configs={[
                                { mass: 1, tension: 220, friction: 100 },
                                { mass: 1, tension: 180, friction: 130 },
                                { mass: 1, tension: 280, friction: 90 },
                                { mass: 1, tension: 180, friction: 135 },
                                { mass: 1, tension: 260, friction: 100 },
                                { mass: 1, tension: 210, friction: 180 },
                                ]}
                            >
                            </AnimatedNumbers>+
                        </h1>
                    </div>
                    <div className="motion">
                        <h3>Konstruksi</h3>
                        <h1 className="d-flex">
                            <AnimatedNumbers
                                includeComma
                                animateToNumber={num2}
                                fontStyle={{ fontSize: 80 }}
                                configs={[
                                { mass: 1, tension: 220, friction: 100 },
                                { mass: 1, tension: 180, friction: 130 },
                                { mass: 1, tension: 280, friction: 90 },
                                { mass: 1, tension: 180, friction: 135 },
                                { mass: 1, tension: 260, friction: 100 },
                                { mass: 1, tension: 210, friction: 180 },
                                ]}
                            >
                            </AnimatedNumbers>+
                        </h1>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div className="testimoni">
        <div className="reviews">
            <Testimonial />
        </div>
    </div>
    <Footer />
    </>
  )
}

export default Home